import React, { useState } from "react"
import { SortableTh } from "../../components/SortableColumns"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { useNavigate } from "react-router-dom"
import { Tab, Tabs } from "react-bootstrap"
import { GenericLinks } from "../../components/Table/GenericLink"

export const TranslationsOverview = () => {
    const [translationApp, setTranslationApp] = useState("USER")
    const [translationLanguage, setTranslationLanguage] = useState("NL")

    const translationEndpoint = `/v2/management/translations`

    const navigate = useNavigate()

    const jsonDataField = (setData, data) => setData(data.translations)

    const filter = {
        initial: [
            [
                ["accepted", "=", "true"],
                ["AND"],
                ["app", "=", translationApp],
                ["AND"],
                ["language", "=", translationLanguage],
            ],
        ],
        onSearch: (filters, searchText) => {
            filters.push(["AND"])
            filters.push(["key", "ilike", searchText])
            filters.push(["OR"])
            filters.push(["translation", "ilike", searchText])
            return filters
        },
    }

    const error = {
        title: "Failed to get translations",
        body: "Something went wrong while getting the translations, see the console for more details.",
    }

    const table = {
        header: [
            <SortableTh column="key">Key</SortableTh>,
            <SortableTh column="translation">Translation</SortableTh>,
            <th>Actions</th>,
        ],
        body: (value) => {
            return (
                <tr key={value.translation_id}>
                    <td>{value.key}</td>
                    <td>{value.translation}</td>
                    <td>
                        <GenericLinks
                            items={[
                                {
                                    onClick: () => {
                                        navigate(`/translations/${value.translation_id}`)
                                    },
                                    text: "Edit",
                                },
                            ]}
                        />
                    </td>
                </tr>
            )
        },
    }

    return (
        <>
            <Tabs
                defaultActiveKey="NL"
                className="mb-3"
                onSelect={(k) => setTranslationLanguage(k || "NL")}
            >
                <Tab eventKey="NL" title="Dutch" />
                <Tab eventKey="EN" title="English" />
                <Tab eventKey="DE" title="German" />
                <Tab eventKey="SE" title="Swedish" />
                <Tab eventKey="ES" title="Spanish" />
            </Tabs>

            <div className="mb-3">
                <label className="me-3">App:</label>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="appOptions"
                        id="userAppOption"
                        value="USER"
                        checked={translationApp === "USER"}
                        onChange={(e) => setTranslationApp(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="userAppOption">
                        User
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="appOptions"
                        id="installerAppOption"
                        value="INSTALLER"
                        checked={translationApp === "INSTALLER"}
                        onChange={(e) => setTranslationApp(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="installerAppOption">
                        Installer
                    </label>
                </div>
            </div>
            <div className="mb-9">
                <GenericOverview
                    apiEndpoint={translationEndpoint}
                    dataField={jsonDataField}
                    searchLength={0}
                    filter={filter}
                    error={error}
                    table={table}
                />
            </div>
        </>
    )
}
